export default String.raw`
{% if include -%}
    {% assign pageName = include -%}
{% endif -%}

{% assign currency = customer.CurrencyExt.Symbol -%}

{% assign ifAvailable = true -%}
{% if product.Availability.Status == 3 -%}
    {% assign ifAvailable = false -%}
{% endif -%}

{% assign productWithAttributes = product.HasAttributes -%}

<div class="card-product">
    <a tabindex="-1" href="{{ page.BaseHref }}{{ product.Url }}" class="card-product__image not-focusable-js">
        <div class="card-product__image-flags">
            {% for flag in product.Flags limit:2 -%}
                <div class="ribbon {{flag.Type}}">
                    {% if flag.Type == "Reward" -%}
                        {{ translations.PointsProduct }}
                    {% else -%}
                        {{ flag.Text }}
                    {% endif -%}
                </div>
            {% endfor -%}
        </div>
        
        {% if product.Image -%}
            {{product | Img2: 'large' }}
        {% else %}
            <svg width="150" height="150">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
            </svg>
        {% endif -%}
    </a>
    <div class="card-product__info">
        <a href="{{ page.BaseHref }}{{ product.Url }}" class="card-product__name" title="{{product.NameNoHtml | H}}"> 
            {{product.NameNoHtml | H}}
        </a>
        {% if customer.HidePrices == true and customer.Authenticated == false -%}
            <div class="label sign-in">
                <div class="label__icon">
                    <svg width="16" height="19">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
                    </svg>
                </div>
                <span class="label__text">{{translations.SignInToSeePrice}}</span>
            </div>
            {% if product.PreviousPrice != null -%}
                <div class="card-product__info-group">
                    <small class="card-product__price-lowest">
                        {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
                            {{ product.PreviousPrice }} <span class="currency">{{currency}}</span>
                            {% if customer.Cart.SubtotalPrices -%}
                                {{translations.Netto | Downcase}}
                            {% else -%}
                                {{translations.Brutto | Downcase}}
                            {% endif -%}
                            - {{translations.SuggestedRetailPrice}}
                        {% else -%}
                            {{ product.PreviousPrice }} <span class="currency">{{currency}}</span>
                            {% if customer.Cart.SubtotalPrices -%}
                                {{translations.Netto | Downcase}}
                            {% else -%}
                                {{translations.Brutto | Downcase}}
                            {% endif -%}
                            - {{translations.PreviousPrice}}
                        {% endif -%}
                    </small>
                </div>
            {% endif -%}
        {% else -%}
            {% if product.AskForPrice == true -%}
                <div class="card-product__info-group">
                    <div class="card-product__prices">
                        <b class="card-product__price-current">&nbsp;<span class="currency">&nbsp;</span></b>
                    </div>
                    {% if settings.lowestProductPrice == 'yes'-%}
                    <small class="card-product__price-lowest">
                        &nbsp;
                    </small>
                    {% endif -%}
                </div>
            {% else -%}
                <div class="card-product__info-group">
                    <div class="card-product__prices">
                        <b class="card-product__price-current">{{product.Price|ToPrice}}<span class="currency">{{currency}}</span></b>
                        {% if product.PreviousPrice != null and product.PreviousPrice > product.Price and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
                            <s class="card-product__price-previous">
                                {{product.PreviousPrice|ToPrice}} <span class="currency">{{currency}}</span>
                            </s>
                        {% elseif product.RegularPrice > product.Price and config.ENTERPRISE and settings.minimalPrice == 'minimalPriceNo' %}
                            <s>
                                {{product.RegularPrice|ToPrice}} <span class="currency">{{currency}}</span>
                            </s>
                        {% endif %}
                        <span class="card-product__price-tax">
                            {% if customer.Cart.SubtotalPrices -%}
                                {{translations.Netto | Downcase}}
                            {% else -%}
                                {{translations.Brutto | Downcase}}
                            {% endif -%}
                        </span>
                    </div>
                    {% if product.DepositValue > 0 -%}
                        <small class="card-product__deposit-price">
                            <span>+ {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{currency}} / {{ product.BasicUnit }}</span>
                        </small>
                    {% endif -%}
                    {% if settings.lowestProductPrice == 'yes'-%}
                        <small class="card-product__price-lowest">
                            {% if product.MinPrice != null -%}
                                {{product.MinPrice | Round: config.DecimalPlacesPrice | ToPrice }}
                                <span class="currency">{{currency}}</span>
                                {% if customer.Cart.SubtotalPrices -%}
                                    {{translations.Netto | Downcase}}
                                {% else -%}
                                    {{translations.Brutto | Downcase}}
                                {% endif -%}
                                {{translations.Price_Omnibus}}
                            {% else -%}
                            &nbsp;
                            {% endif -%}
                        </small>
                    {% endif -%}
                    {% if  settings.previousPriceAsSuggestedRetailPrice == 'yes' and product.PreviousPrice != null and product.PreviousPrice > product.Price -%}
                        <small class="card-product__price-lowest">
                            {{ product.PreviousPrice | ToPrice}} <span class="currency">{{currency}}</span>
                            {% if customer.Cart.SubtotalPrices -%}
                                {{translations.Netto | Downcase}}
                            {% else -%}
                                {{translations.Brutto | Downcase}}
                            {% endif -%}
                            - {{translations.SuggestedRetailPrice}}
                        </small>
                    {% endif -%}
                </div>
            {% endif -%}
        {% endif -%}
    </div>
    <div class="card-product__buttons form-js add-to-cart-js container-js">
    {% if customer.HidePrices == 'true' and customer.Authenticated == 'false' -%}
        {% if settings.signIn == "page" -%}
            <a class="secondary-action-button" aria-label="{{ translations.LogIn }}" href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}" rel="nofollow" title="{{ translations.LogIn }}">
                <span class="button__text">{{translations.LogIn}}</span>
                <div class="button__icon">
                    <svg width="18" height="20" >
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                    </svg>
                </div>                
            </a>
        {% else -%}
            <a class="secondary-action-button show-login-popup-js" aria-label="{{ translations.LogIn }}" rel="nofollow" title="{{ translations.LogIn }}">
                <span class="button__text">{{translations.LogIn}}</span>
                <div class="button__icon">
                    <svg width="18" height="20" >
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                    </svg>
                </div>                
            </a>
        {% endif -%}
    {% elseif product.Price == null or product.AskForPrice -%}
        <div class="button__group button__group">
            <a class="primary-action-button" href="{{ page.BaseHref }}{{ product.Url }}" >
                <span class="button__text">{{translations.AskForPrice}}</span>
                <div class="button__icon">
                    <svg width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
                    </svg>
                </div>
            </a>
        </div>
    {% elseif ifAvailable == false and productWithAttributes == false -%}
        <div class="button__group">
            <a class="primary-action-button choose-variant-js" href="{{ page.BaseHref }}{{ product.Url }}">
                <span class="button__text">{{translations.NotifyAboutAvailability}}</span>
            </a>
            {% if customer.Authenticated -%}
                <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js {% endif -%}" data-product-id="{{product.Id}}">
                    <svg class="button__icon" width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
                    </svg>                              
                </button>
            {% endif -%}
        </div>
    {% elseif productWithAttributes -%}
        <div class="button__group">
            <button data-url="{{ page.BaseHref }}{{ product.Url }}" {% if pageName == 'lookbook' -%} data-lookbook="true" {% endif -%} class="primary-action-button choose-variant-js">
                <span class="button__text">{{ translations.AvailableProductVariants }}</span>
                <svg class="button__icon">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                </svg>
            </button>
        </div>
    {% else -%}
        <div class="button__group">
            <input type="hidden" name="__action" value="Cart/Add" >
            <input type="hidden" name="productId" value="{{product.Id}}">
            <input type="hidden" name="quantity" value="1" >
            <!-- cart-js -->
            <button data-url="{{ page.BaseHref }}{{ product.Url }}" class="primary-action-button add-to-cart-update-client-area-js parent-container-reload-js" aria-label="{{ translations.AddToCart }}">
                <span class="button__text">{{ translations.AddToCart }}</span>
                <svg class="button__icon" aria-hidden="true">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
                </svg>
            </button>
            {% if customer.Authenticated -%}
                <button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js {% endif -%}" data-product-id="{{product.Id}}">
                    <svg class="button__icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
                    </svg>                    
                </button>
            {% endif -%}
        </div>
    {% endif -%}
    </div>
</div>
`